import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white border-b border-gray-100" data-id="element-139">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <FadeIn data-id="element-141">
          <div className="bg-gradient-to-br from-warm-beige/40 to-warm-beige/10 rounded-3xl p-8 md:p-12 text-center border-2 border-warm-beige shadow-lg relative overflow-hidden" data-id="element-142">
            {/* Decorative background */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-143">
              <div className="absolute -top-24 -right-24 w-64 h-64 bg-olive-green/20 rounded-full blur-3xl" data-id="element-144"></div>
              <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-terracotta/10 rounded-full blur-3xl" data-id="element-145"></div>
            </div>

            <div className="inline-flex items-center justify-center bg-white text-olive-green p-5 rounded-full mb-8 shadow-md border border-warm-beige" data-id="element-146">
              <ShieldCheck size={56} strokeWidth={1.5} data-id="element-147" />
            </div>

            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-148">
              Garantía de 7 días sin preguntas
            </h2>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-149">
              Si revisas el contenido y no te parece claro, útil o práctico, te
              devolvemos tu dinero. Sin complicaciones.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}